import { render } from "./ExperienceColumn.vue?vue&type=template&id=485b4243&scoped=true"
import script from "./ExperienceColumn.vue?vue&type=script&lang=js"
export * from "./ExperienceColumn.vue?vue&type=script&lang=js"

import "./ExperienceColumn.vue?vue&type=style&index=0&id=485b4243&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485b4243"]])

export default __exports__